'use strict';

var React = require('react');

var SvgItalicMajor = function SvgItalicMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.25c0-.41.34-.75.75-.75h6a.75.75 0 0 1 0 1.5h-2.34l-2.28 10h2.12a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5h2.34l2.28-10h-2.12a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgItalicMajor.displayName = "ItalicMajor";

exports.SvgItalicMajor = SvgItalicMajor;
